if (typeof window.dataLayer === "undefined") {
  window.dataLayer = [];
}

if (typeof window.sentDataLayerEvents === "undefined") {
  window.sentDataLayerEvents = [];
}

export const push = event => {
  window.dataLayer.push(event);
};

export const sendEvent = event => {
  const eventName = event.event;

  window.sentDataLayerEvents.push(eventName);

  push(event);
};

export const sendUniqEvent = event => {
  const eventName = event.event;

  if (window.sentDataLayerEvents.indexOf(eventName) === -1) {
    sendEvent(event);
  }
};
